<div class="selection-container">
  <!-- 左側：管理者 -->
  <div class="panel panel--admin">
    <div class="panel__inner">
      <div class="icon-placeholder">
        <img src="assets/img/admin.svg" alt="管理者アイコン" />
        <!-- <span class="icon-placeholder__label">アイコン</span> -->
      </div>

      <h2 class="panel__title">管理者・個人事業主の方</h2>
      <!-- <h2 class="panel__title">管理者</h2> -->
      <ul class="panel__features panel__features__admin">
        @for (feature of adminFeatures; track feature) {
          <li>{{ feature }}</li>
        }
      </ul>

      <button class="btn btn--admin" (click)="onAdminRegister()">管理者登録</button>
    </div>
  </div>

  <!-- 右側：一般の方 -->
  <div class="panel panel--user">
    <div class="panel__inner">
      <div class="icon-placeholder">
        <img src="assets/img/standard.svg" alt="一般ユーザーアイコン" />
        <!-- <span class="icon-placeholder__label">アイコン</span> -->
      </div>

      <h2 class="panel__title">一般の方</h2>

      <ul class="panel__features panel__features__standard">
        @for (feature of userFeatures; track feature) {
          <li>{{ feature }}</li>
        }
      </ul>

      <button class="btn btn--user" (click)="onUserRegister()">一般利用者登録</button>
    </div>
  </div>
</div>
